import Layout from "@/views/layout";

const activityRouter = {
  path: "/activity",
  name: "Activity",
  component: Layout,
  meta: { title: "活动模块" },
  children: [
    {
      path: "apply",
      name: "Apply",
      component: () => import("@/views/activity/apply"),
      meta: { title: "活动申请" }
    },
    {
      path: "publicity",
      name: "Publicity",
      component: () => import("@/views/activity/publicity"),
      meta: { title: "活动预览" }
    },
    {
      path: "list",
      name: "List",
      component: () => import("@/views/activity/list"),
      meta: { title: "活动列表" }
    },
    {
      path: "record",
      name: "Record",
      component: () => import("@/views/activity/record"),
      meta: { title: "活动记录" }
    },
    {
      path: "sale",
      name: "Sale",
      component: () => import("@/views/activity/sale"),
      meta: { title: "销售记录" }
    },
    {
      path: "auditResult",
      name: "AuditResult",
      component: () => import("@/views/activity/auditResult"),
      meta: { title: "审核结果" }
    },
    {
      path: "edit",
      name: "Edit",
      component: () => import("@/views/activity/edit"),
      meta: { title: "活动修改" }
    }
  ]
};

export default activityRouter;
